import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import { auth, users, baustellen, archiv, angebote } from '../fbConfig';

Vue.use(Vuex);

// Firebase Authentication Observer
auth.onAuthStateChanged(user => {
  if (user) {
    store.dispatch('userLogin', user);
  } else {
    store.dispatch('userLogout');
  }
});

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    baustellen: [],
    archiv: [],
    angebote: [],
    dataLoaded: false,
    loading: true
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val;
    },
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setBaustellen(state, val) {
      state.baustellen = val;
    },
    setArchiv(state, val) {
      state.archiv = val;
    },
    setAngebote(state, val) {
      state.angebote = val;
    },
    setDataLoaded(state, val) {
      state.dataLoaded = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    clearData(state) {
      state.currentUser = null;
      state.userProfile = {};
      state.baustellen = [];
      state.archiv = [];
      state.angebote = [];
      state.dataLoaded = false;
    }
  },
  actions: {
    async userLogin({ commit, dispatch }, user) {
      commit('setCurrentUser', user);
      commit('setLoading', true);
      await dispatch('fetchUserProfile');
      await dispatch('fetchAllData');
      commit('setLoading', false);
      commit('setDataLoaded', true);
    },
    userLogout({ commit }) {
      commit('clearData');
    },
    fetchUserProfile({ commit, state }) {
      return users.doc(state.currentUser.uid).get()
        .then(res => {
          commit('setUserProfile', res.data());
        })
        .catch(err => {
          console.error("Error fetching user profile:", err);
        });
    },
    fetchAllData({ dispatch }) {
      return Promise.all([
        dispatch('fetchBaustellen'),
        dispatch('fetchArchiv'),
        dispatch('fetchAngebote')
      ]);
    },
    fetchBaustellen({ commit }) {
      return baustellen.orderBy('createdOn', 'desc').get()
        .then(querySnapshot => {
          let baustellenArray = [];
          querySnapshot.forEach(doc => {
            let baustelle = doc.data();
            baustelle.id = doc.id;
            baustellenArray.push(baustelle);
          });
          commit('setBaustellen', baustellenArray);
        })
        .catch(err => {
          console.error("Error fetching baustellen:", err);
        });
    },
    fetchArchiv({ commit }) {
      return archiv.orderBy('createdOn', 'desc').get()
        .then(querySnapshot => {
          let archivArray = [];
          querySnapshot.forEach(doc => {
            let baustelle = doc.data();
            baustelle.id = doc.id;
            archivArray.push(baustelle);
          });
          commit('setArchiv', archivArray);
        })
        .catch(err => {
          console.error("Error fetching archiv:", err);
        });
    },
    fetchAngebote({ commit }) {
      return angebote.orderBy('createdOn', 'desc').get()
        .then(querySnapshot => {
          let angebotArray = [];
          querySnapshot.forEach(doc => {
            let angebot = doc.data();
            angebot.id = doc.id;
            angebotArray.push(angebot);
          });
          commit('setAngebote', angebotArray);
        })
        .catch(err => {
          console.error("Error fetching angebote:", err);
        });
    }
  },
  getters: {
    nextORg: state => {
      let x = [];
      let n = 0;
      state.baustellen.forEach(el => el.zahlungsplan.forEach(zp => {
        zp.id = el.id;
        zp.adresse = el.adresse;
        zp.bauherr = el.bauherr;
        zp.idx = n + 1;
        x.push(zp);
        n++;
      }));
      let f = x.filter(el => {
        if (el.verrechnet) {
          return el.verrechnet == false;
        } else {
          return el.bezahlt == false;
        }
      });
      let s = f.sort((a, b) => new Date(a.datum) - new Date(b.datum));
      return s.slice(0, 5);
    },
    auftraggeberList: state => {
      let bst = state.baustellen;
      let ags = [];
      let n = 0;
      let uniqueAg = [...new Set(bst.map(item => item.auftraggeber))];
      uniqueAg.forEach(item => {
        ags.push({
          ag: item,
          count: bst.filter(obj => obj.auftraggeber == item).length,
          idx: n + 1
        });
        n++;
      });
      let s = ags.sort((a, b) => b.count - a.count);
      return s.slice(0, 10);
    },
    bezahltSumme: state => {
      let bezRg = [];
      state.baustellen.forEach(el => el.zahlungsplan.forEach(zp => {
        if (zp.bezahlt && zp.summe) {
          bezRg.push(zp.summe);
        }
      }));
      return bezRg.reduce((a, b) => a + b, 0);
    },
    verrechnetSumme: state => {
      let verrRg = [];
      state.baustellen.forEach(el => el.zahlungsplan.forEach(zp => {
        if (zp.bezahlt || zp.verrechnet && zp.rechnungsbetrag) {
          verrRg.push(zp.rechnungsbetrag);
        }
      }));
      return verrRg.reduce((a, b) => a + b, 0);
    },
    trsAbHeute: state => {
      let verrRg = [];
      state.baustellen.forEach(el => el.zahlungsplan.forEach(zp => {
        if (zp.rechnungsbetrag && moment(zp.datum, 'YYYY-MM-DD').isAfter(moment())) {
          verrRg.push(zp.rechnungsbetrag);
        }
      }));
      return verrRg.reduce((a, b) => a + b, 0);
    },
    aufragssummen: state => {
      let a = [];
      state.baustellen.forEach(el => {
        if (el.auftragssumme) {
          a.push(el.auftragssumme);
        }
      });
      return a.reduce((a, b) => a + b, 0);
    },
    bstPlusArchiv: state => {
      return state.baustellen.concat(state.archiv);
    }
  }
});
